import { Clock, Calendar, Store, X } from "lucide-react";
import { Button } from "./ui/button";

const OrderPausedModal = ({ 
  isOpen, 
  onClose, 
  message, 
  resumeAt,
  onBrowseRestaurants 
}) => {
  if (!isOpen) return null;

  // Format resume time if available
  const formatResumeTime = (isoString) => {
    if (!isoString) return null;
    try {
      const date = new Date(isoString);
      const now = new Date();
      const isToday = date.toDateString() === now.toDateString();
      const isTomorrow = date.toDateString() === new Date(now.getTime() + 86400000).toDateString();
      
      const timeStr = date.toLocaleTimeString('en-IN', { 
        hour: 'numeric', 
        minute: '2-digit',
        hour12: true 
      });
      
      if (isToday) {
        return `${timeStr} today`;
      } else if (isTomorrow) {
        return `${timeStr} tomorrow`;
      } else {
        return date.toLocaleDateString('en-IN', { 
          weekday: 'short',
          day: 'numeric', 
          month: 'short',
          hour: 'numeric',
          minute: '2-digit',
          hour12: true
        });
      }
    } catch {
      return null;
    }
  };

  const formattedResumeTime = formatResumeTime(resumeAt);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
      <div className="bg-white rounded-2xl max-w-sm w-full shadow-2xl overflow-hidden animate-slideUp">
        {/* Header */}
        <div className="bg-gradient-to-r from-amber-500 to-orange-500 p-6 text-center relative">
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-white/80 hover:text-white transition-colors"
            data-testid="order-paused-close-btn"
          >
            <X size={24} />
          </button>
          <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-3 shadow-lg">
            <Clock size={32} className="text-amber-500" />
          </div>
          <h2 className="text-xl font-bold text-white">
            We&apos;ll Be Back!
          </h2>
        </div>

        {/* Content */}
        <div className="p-6 text-center">
          <p className="text-gray-700 mb-4 leading-relaxed">
            {message || "Thank you for your overwhelming response! We are currently not accepting new orders."}
          </p>
          
          <p className="text-gray-600 text-sm mb-4">
            We will be back soon!
          </p>

          {formattedResumeTime && (
            <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 mb-6">
              <div className="flex items-center justify-center gap-2 text-amber-700">
                <Calendar size={18} />
                <span className="font-medium">Expected: {formattedResumeTime}</span>
              </div>
            </div>
          )}

          {/* Actions */}
          <div className="space-y-3">
            {onBrowseRestaurants && (
              <Button
                onClick={onBrowseRestaurants}
                className="w-full h-12 bg-[#3FA9F5] hover:bg-[#2196F3] text-white font-semibold rounded-full"
                data-testid="browse-restaurants-btn"
              >
                <Store size={18} className="mr-2" />
                Browse Restaurants
              </Button>
            )}
            <button
              onClick={onClose}
              className="w-full text-gray-500 text-sm hover:text-gray-700"
              data-testid="order-paused-dismiss-btn"
            >
              Go Back
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderPausedModal;
